import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "slides" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("figure", { class: "welcome" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: "/images/welcome.svg",
        alt: "welcome to the vincent memorial catholic high school webpage"
    })
], -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.images.length > 0)
        ? (_openBlock(), _createElementBlock("section", {
            key: 0,
            id: _ctx.eleId
        }, [
            _createElementVNode("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, index) => {
                    return (_openBlock(), _createBlock(_TransitionGroup, {
                        key: image.id,
                        name: `${_ctx.eleId}-list`
                    }, {
                        default: _withCtx(() => [
                            (index === _ctx.currentBannerSlide)
                                ? (_openBlock(), _createElementBlock("figure", {
                                    key: 0,
                                    style: _normalizeStyle(`background-image: url(${image.uri})`)
                                }, null, 4 /* STYLE */))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["name"]));
                }), 128 /* KEYED_FRAGMENT */))
            ]),
            _hoisted_3
        ], 8 /* PROPS */, _hoisted_1))
        : _createCommentVNode("v-if", true);
}
